import React, { useState } from 'react';
import { motion } from 'framer-motion';

export const CheckboxField = ({ 
  id, 
  label, 
  value = [], 
  onChange, 
  options = [], 
  required = false,
  error = null,
  helpText = null,
  allowOther = false
}) => {
  const [otherValue, setOtherValue] = useState('');
  const [showOther, setShowOther] = useState(false);

  const handleCheckboxChange = (option) => {
    const newValue = value.includes(option)
      ? value.filter(v => v !== option)
      : [...value, option];
    
    if (option === 'Other (please specify)' && !value.includes(option)) {
      setShowOther(true);
    } else if (option === 'Other (please specify)' && value.includes(option)) {
      setShowOther(false);
      setOtherValue('');
    }
    
    onChange(newValue);
  };

  const handleOtherChange = (text) => {
    setOtherValue(text);
    const newValue = value.filter(v => v !== 'Other (please specify)' && !v.startsWith('Other: '));
    newValue.push('Other (please specify)');
    if (text.trim()) {
      newValue.push(`Other: ${text}`);
    }
    onChange(newValue);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="mb-6"
    >
      <label className="block text-sm font-semibold text-gray-200 mb-3">
        {label}
        {required && <span className="text-red-400 ml-1">*</span>}
      </label>
      
      {helpText && (
        <p className="text-sm text-gray-400 mb-3">{helpText}</p>
      )}
      
      <div className="space-y-2">
        {options.map((option, index) => {
          const checkboxId = `${id}_${index}`;
          const isChecked = value.includes(option);
          
          return (
            <motion.div
              key={index}
              whileHover={{ scale: 1.01 }}
              className={`flex items-start p-3 rounded-lg border ${
                isChecked
                  ? 'border-teal-500 bg-teal-500/10'
                  : 'border-gray-700 bg-gray-800/50'
              } cursor-pointer transition-all`}
              onClick={() => handleCheckboxChange(option)}
            >
              <input
                type="checkbox"
                id={checkboxId}
                checked={isChecked}
                onChange={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
                readOnly
                className="mt-1 h-4 w-4 text-teal-500 border-gray-600 rounded focus:ring-teal-500 focus:ring-offset-gray-900 cursor-pointer pointer-events-none"
              />
              <label
                htmlFor={checkboxId}
                className="ml-3 text-sm text-gray-200 cursor-pointer flex-1 select-none"
              >
                {option}
              </label>
            </motion.div>
          );
        })}
      </div>

      {allowOther && showOther && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          className="mt-3"
        >
          <input
            type="text"
            value={otherValue}
            onChange={(e) => handleOtherChange(e.target.value)}
            placeholder="Please specify..."
            className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
          />
        </motion.div>
      )}
      
      {error && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="text-red-400 text-sm mt-2"
        >
          {error}
        </motion.p>
      )}
    </motion.div>
  );
};

